<template>
    <panel-navigation>

      <dialog-send-test-email ref="dialogSendTestEmail"></dialog-send-test-email>

    <dialog-buy-number ref="dialogBuyNumber"></dialog-buy-number>

    <div v-if="show_google_ads_popup" @click.self="show_google_ads_popup = false" class="fixed top-0 left-0 h-full w-full z-50 flex flex-column items-center justify-center" style="background-color: rgba(0,0,0,.2);">
      <div class="w-full sm:w-1/2 lg:w-2/5 bg-white rounded-lg mx-6">

        <div class="rg-modal-header">
           Google Ads Connection

          <a href="javascript: void(0);" class="rg-modal-close-btn" @click="show_google_ads_popup = false"><i class="mdi mdi-close"></i></a>
        </div>

        <div class="p-6">

          <!-- <div class="text-center -mb-4" style="position: relative;">
            <a href="https://ads.google.com/" class="text-xs" target="lsa-google-ads-link">Sign Up for Google Ads</a>
          </div> -->

          <div style="clear: both;"></div>

          <div class="">

            <div v-if="me.integrations.google_ads.status == 1">
              <div class="flex flex-row flex-wrap">
                <div :class="'w-full mb-3'">
                  <button class="rg-dialog-button-save rounded text-white text-xs text-bold focus:outline-none py-2 -mt-2 mb-2 px-4 float-right" @click="connectGoogleAdsAccount">
                      CONNECT ANOTHER ACCOUNT
                  </button>
                  
                  <p class="mb-1 text-xs mb-2"><strong>Connected Account</strong></p>
                  <input type="text" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded"
                  :class="(($vuetify.breakpoint.mobile) ? 'mb-2' : '')"
                  :value="me.integrations.google_ads.settings.oauth_account.name + ' (' + me.integrations.google_ads.settings.oauth_account.email + ')'"
                  readonly
                  />
                </div>
                <div :class="'w-full mb-3'" style="position: relative;">
                  <p class="mb-1 text-xs mb-2"><strong>Select Google Ads MCC</strong></p>
                  
                  <v-select
                    v-model="me.integrations.google_ads.settings.selected_manager_id"
                    outlined dense
                    hide-details
                    :item-text="item => item.name"
                    :item-value="item => item.id"
                    :items="me.integrations.google_ads.settings.managers"
                    class="-mt-2"
                  ></v-select>
                </div>
              </div>

              <div v-if="me.integrations.google_ads.settings.managers.length == 0" class="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 mb-4 mt-1" role="alert">
                <div>There are no Google Ads MCC accounts found. Please connect a different account.</div>
              </div>
            </div>
            <div v-else class="text-center p-10">
              <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="display: inline-block;">
              <rect opacity="0.1" width="70" height="70" rx="5" fill="#44468F"/>
              <rect x="16" y="18" width="37.1733" height="34" fill="url(#pattern0)"/>
              <defs>
              <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
              <use xlink:href="#image0_1047_27365" transform="scale(0.00609756 0.00666667)"/>
              </pattern>
              <image id="image0_1047_27365" width="164" height="150" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKQAAACWCAYAAABQByPnAAAYhmlDQ1BJQ0MgUHJvZmlsZQAAWIWVeQdYU03z755UAgm99957L1JCr9I7CiG00KWDIAqIAirYEAFFmkgXLCAiAlJEEaQICBZAUVFULChK+x+Kfu///e5z73M3z57zy+zs7M7s7sxOAgBXFyk8PBhBD0BIaFSEnYk+v4urGz/2LYAAAv5AAEUiR4YTbWwsAVz+vP93+TEG88FlRGZT1n+3/18Lo49vJBkAyAPG3j6R5BAYtwOASiGHR0QBgDGE6UKxUeGbOADGzBHwBGGcuIn9t3HOJvbexmVbPA52BjBuBoAKTyJF+ANA2wXT+WPI/rAc2tdwG2OoDyUUZl2GsQ45gOQDAJc6zCMdEhK2ieEKxGH+cBgfg7G69z9k+v8v+d5/5ZNI/n/xtl5bhcqQEhkeTIr//zTN/7uEBEf/GUMUrviACFO7Tf1hG04EhVlsYjyMF0K9d1tv2hrGyxSfbbsDgKAOiDZ13OZHcJMjDWD7AVYYy/uQDC1gzA1j49Dg3ZY7dG8/irEZjOHdgoijRJk57PQ96htpZL8jszAizM76D/aLMCDu9K0jRWyNu8nfFR3kSNyRPxHga/ZH/veEAAdnGFMDgKSOoTjthjEtjJkjg+wttnmQggkBBrv/8ERE223OXxjG6r6hJvrb8pEefhHGdjv84SGRf/RFpgdQzHbv4LyoAAfTbfsgq8ikrfmzw/imbyjR8Y8c30gXyz+6+PgaGm3rjhzwDXXc0Rf5IjxK326n72J4sM0OP4rKN9hkky4IY87IGPudvqhdUfDm3JaPsgyPsnHYnifKK5BkbrM9H1QMsAQGwBDwg2i4eoMwEAgoAwtNC/C37RZjQAIRwB/4Apkdyp8ezlstofDTHiSAjzDyBZF/++lvtfqCGJi+9pe6/ZQBflutMVs9gsAbGIcACxAMf4/e6hX6dzQn8BqmUP5rdDI812C4brb9N40IUyx3KNF/5PLT/eHEGGEMMaYYY4wEihOlg9JCWcJPPbgqotRRGn9m+x9+9Bv0EHoW/QQ9jX7qSUmJ+NdcrMA0LN94R2Pvf2qMEoVlqqD0UdqwdFgyihXFCWRQyvA4RJQuPLIKTDXYmfem7vz/Bz3/avAPm+/w4eRxCBwbTg8n/u+etJK0Kn+lbFr0n/bZnqv3X6sa/G359/gG/7CzD/y2+Dcn8ijyGrIX2YHsQ7YimwA/8i6yGdmPvLOJ/+6h11t76M9odlvzCYLlUP5rPNLOmJuWjJSvlp+XX91pA1G+cVGbB8wgLDw+guIfEMVPhKOAL79ZKFlWml9RXlEJgM2Ysu2mvtltxQqIdfA/NMoYAKoNmz7rPzR/+Fy0zAKAs/wPTaQGdgewz76PI0dHxGzTUJsPNOwN6OATxQF4gRAQhzVSBKpAC+gBI2AOrIEDcAV7YTsHwPs5AsSCRHAIpIMskAPOgnxQBErBFVALGkETaAUdoAc8BI/BEzAF75858AEsgh9gBYIgLESAmCAOiA8SgaQgRUgd0oGMIEvIDnKFvCB/KBSKhhKhVCgLOgXlQ8VQJdQA3YI6oD5oCHoKzUDz0FfoNwKJwCOYETwIUYQcQh1BRFggHBB7EP6IfYgERBriBCIPUYKoQdxEdCAeIp4gphEfEEtIgKRBsiIFkDJIdaQB0hrphvRDRiAPIDORucgSZB2yBV7pEeQ0cgH5C4VBMaH4UTLwHjZFOaLIqH2oA6hjqHzUFdRNVBdqBDWDWkStowlobrQUWhNthnZB+6Nj0enoXPRl9A10N3ya5tA/MBgMK0YMowafRldMIGY/5hjmAqYe044ZwrzCLGGxWA6sFFYba40lYaOw6djz2BrsXewwdg67TEVDxUelSGVM5UYVSpVClUtVRdVGNUz1lmoFR48TwWnirHE+uHhcNq4M14IbxM3hVqgZqMWotakdqAOpD1HnUddRd1M/o/5GQ0MjSKNBY0tDoTlIk0dzleY+zQzNLzwjXhJvgPfAR+NP4Cvw7fin+G8EAkGUoEdwI0QRThAqCfcILwjLtEy0srRmtD60ybQFtDdph2k/0eHoROiIdHvpEuhy6a7RDdIt0OPoRekN6En0B+gL6G/Rj9MvMTAxKDBYM4QwHGOoYuhjeMeIZRRlNGL0YUxjLGW8x/iKCckkxGTARGZKZSpj6maaY8YwizGbMQcyZzHXMg8wL7IwsiizOLHEsRSw3GGZZkWyirKasQazZrM2so6x/mbjYSOy+bJlsNWxDbP9ZOdi12P3Zc9kr2d/wv6bg5/DiCOI4yRHE8dzThSnJKctZyznRc5uzgUuZi4tLjJXJlcj1yQ3gluS2457P3cpdz/3Eg8vjwlPOM95nns8C7ysvHq8gbxneNt45/mY+HT4KHxn+O7yvedn4SfyB/Pn8XfxLwpwC5gKRAsUCwwIrAiKCToKpgjWCz4XohZSF/ITOiPUKbQozCdsJZwoXC08KYITURcJEDkn0ivyU1RM1Fn0iGiT6DsxdjEzsQSxarFn4gRxXfF94iXioxIYCXWJIIkLEo8lEZIqkgGSBZKDUggpVSmK1AWpIWm0tIZ0qHSJ9LgMXoYoEyNTLTMjyyprKZsi2yT7SU5Yzk3upFyv3Lq8inywfJn8lAKjgrlCikKLwldFSUWyYoHiqBJByVgpWalZ6YuylLKv8kXlCRUmFSuVIyqdKmuqaqoRqnWq82rCal5qhWrj6szqNurH1O9roDX0NZI1WjV+aapqRmk2an7WktEK0qrSerdLbJfvrrJdr7QFtUnaxdrTOvw6XjqXdKZ1BXRJuiW6s3pCej56l/XeEiWIgcQa4id9ef0I/Rv6Pw00DZIM2g2RhiaGmYYDRoxGjkb5Ri+MBY39jauNF01UTPabtJuiTS1MT5qOm/GYkc0qzRbN1cyTzLss8Bb2FvkWs5aSlhGWLVYIK3Or01bPdovsDt3dZA2szaxPWz+3EbPZZ3PbFmNrY1tg+8ZOwS7Rrteeyd7Tvsr+h4O+Q7bDlKO4Y7RjpxOdk4dTpdNPZ0PnU87TLnIuSS4PXTldKa7Nblg3J7fLbkvuRu5n3ec8VDzSPcb2iO2J29O3l3Nv8N47nnSeJM9rXmgvZ68qr1WSNamEtORt5l3ovUg2IJ8jf/DR8znjM++r7XvK962ftt8pv3f+2v6n/ecDdANyAxYoBpR8ypdA08CiwJ9B1kEVQRvBzsH1IVQhXiG3QhlDg0K7wnjD4sKGwqXC08On92nuO7tvMcIi4nIkFLknsjmKGb6890eLRx+OnonRiSmIWY51ir0WxxAXGtcfLxmfEf82wTihfD9qP3l/Z6JA4qHEmSRiUvEB6ID3gc5koeS05LmDJgevHKI+FHToUYp8yqmU76nOqS1pPGkH014dNjlcnU6bHpE+fkTrSNFR1FHK0YEMpYzzGeuZPpkPsuSzcrNWj5GPPTiucDzv+MYJvxMD2arZF3MwOaE5Yyd1T145xXAq4dSr01anb57hP5N55vtZz7N9ucq5Reeoz0Wfm86zzGs+L3w+5/xqfkD+kwL9gvpC7sKMwp8XfC4MX9S7WFfEU5RV9PsS5dJEsUnxzRLRktxSTGlM6Zsyp7LecvXyysucl7Mur1WEVkxfsbvSValWWVnFXZVdjaiOrp6v8ah5XGtY21wnU1dcz1qfdRVcjb76vsGrYazRorHzmvq1uusi1wtvMN3IvAndjL+52BTQNN3s2jx0y/xWZ4tWy43bsrcrWgVaC+6w3Mluo25La9u4m3B3qT28faHDv+NVp2fn1D2Xe6Ndtl0D3Rbd93uMe+71Envv3te+39qn2XfrgfqDpoeqD2/2q/TfeKTy6MaA6sDNQbXB5scaj1uGdg21DesOd4wYjvSMmo0+fLL7ydCY49jEuMf49ITPxLunwU+/TMZMrkwdfIZ+lvmc/nnuC+4XJS8lXtZPq07fmTGc6Z+1n516RX714XXk69W5tDeEN7lv+d5WvlN81zpvPP/4vfv7uQ/hH1YW0j8yfCz8JP7p+me9z/2LLotzXyK+bHw99o3jW8V35e+dSzZLL36E/Fj5mbnMsXzll/qv3t/Ov9+uxK5iV/PWJNZa1i3Wn22EbGyEkyJIW1cBJFwRfn4AfK0AgOAKANNjOE1w3875dgoSvnwg4LcTJAt9QHQhI1EiqPfoYownVgA7RVWCC6RWpF6lGcQXEaJod9NJ0GPoZxm6GS8zZTCHsTixGrE5s4dwpHNe4mrhHuZZ4MPxCwsQBb2EkoQLRG6JTor9luCS1JHylk6VqZQdlPumwK6oq0RWzlJpUB1S+6RB0JTUMt7lrX1AJ1/3ut4A8a3+uiG7kayxoYmzaZBZovkJi4uWdVZ3dvdbT9q8sf1uDzngHdmcuJ35XIRcxdyk3RU9NPcY7LXwdPQik8K8D5CP+xT5Nvh1+08GLAZSBfEHa4TYh4aFZYaX7+uIeBG5Es0eoxLrELcvPiehfv9g4ucD9MlKBx0PxaUUpnakvUnHH1E66paRklmZNXJs9YRotnVO/MmyU49Ofz5Ll6twzjEv7nxhfkfB2wuEiypFHpdSi6tKhkp/lnNfJlb4XjlSeaWqt/p1zUYde738VZMGj8aIaxnXL964erO16V5zz617Lbdv17bm3znURr6r187W/r7jVueheyZduK4H3ek9xJ6V3uv3g/oE+yYfnHxo2Y/vH3qUO+A2yDs4+7hsyG9YfHh+pGo08Inkkw9j1eNBE9ITH5/WT+6bUp5aftb6/NAL45eEl6PT+TN7ZwVn51/deH1kzvON9luhd/Tz6PeID9QLXB/VPrl/PrLY8uX7N+XvcUttP7HLtr8Kf79ZlV2LXm/Z2NhafyHoKsIVyYBsRLmjqdG1GBf4VlNPRcKx4x5Sp9Ho49H4e4TDtGZ0tHQT9CUMwYxqTFim58z9LD2s7Wx32Js5rnFe5arhruAp4y3lK+UvESgWLBEqE64QqRStFWsQvy7RItkh1S39QGZYdkLuufwLheeKz5QmlcdVnqiOqA2qP9Do1uzQur3runatTpluvl42MVU/1iDQcI/RbmM9EwVTfjN6c2C+aPHMstuqZvdp6/023rZmdvL2HA6Qw7zjsNNt53KXbNcEN193a49de8T2MnlCnp+8pkh93k3kcp/Tvml+h/xTAlIpqYEpQanBKSGpoalhKeEp+1IiUiJTog5FH4w5GJsclxx/ICFpf2JiYtL+AwnJ8Qfj4N2RnVqe1np4NP3DUWQGZ6Zilukxr+OxJ45ll+W0nHx86s3p1bMMuWLntPNsz/vlJxacLCy70HJxsOjVpZ8l+FKBMtVy88t7KyLgHVJQVVfdUTNa+7bu91V8A2+j3DXidbsb5JuRTWnNZ26Vwx6sq3Xkzqu293cft9d2ZHb63zPs4u9a7Z7oudZ74j6lz+ABz4MfDwf7Kx4lDzgNyjxGPZ4cahhOH/EYVXiCfjI11jCeOUF5ajGpOMX3jOk53QumlwLTWjNes6dfjc6Jvzn2DsxnfBBcePQpY9H2q/h3mqXln59/vV/5uPZta/2lQBdkAU0g3BEfkUHIZVQKmh1dglHBPIRvtGtUBTgd3DT1ERpFmpf4LMIuwgLtBTo7ehr6boYTjJ5MCswo5lGWctY4Nit2PvYljgecxVxx3NY84rwQ7yTfNf5sgUBBYyEhoXX4HtUsmisWJW4jIS6xKjkkVS4dL2MlKyD7Ra5D/qSCl6Ks4i+lTtg/2Kuyq06pFamTNAQ1ZjSLtPbu4to1rn1ax1qXoDusl08k60vrfzO4bZhmZGnMbDxlUgr7C0WzX+btFkcsra1Y4ftEiTXFRtbmu22LXbK9kQO1w4DjSScHZzbnSZeLrt5u4m6f3G96HNxjvpd172v4HpBGcvaWJiPIkz7XfXP8QvwtAqQoNJSPgY+DrgfnhsSGuoRphnOFr+17GdERWRqVHk2JsYpViGONW4mfTXiwvzGxIOnwgfBkj4Nmh1RThFIZ06C0L4ffpM8dmT/6KeNr5o+s38fWTyCyMTm4k4RT9KeZz7Cd5czlPSeQJ3xeLF+yQKZQ4YLyRbUirUs6xcQSi1Jy2aHyosttFZNXlqtYq5VrbGtD6jLrK652NUw3rl5nu6F007opsPnwreKW1ttjrV/a8HdF2/U69nTuv3euq667p+d57/c+ugdyDx37Dz9qG8Q89hzqHbEYnR0rnIidTHh2+SVupub1ubdDH6I/Z3/X+1Wzuf7bv/1tFowqAOW6sEOA44Z9CQClrXCeqQ7Hj3IAbAgAOGgAhEMCgF40A8j1/N/4AcGJJxWghzNOEaC09XtIEEiBc8kbYAh8huggBcgBSoBzwAfQEoILoY8IRJxGtCHeI9mRJshYZCXyGYoeZYxKgnOyRTgPC4BzrzmMCCYAU435jFXBJmF7qOipPKgqqX7iTHGFuK/UZtQl1Gs0bjTNeHZ8Av4FwZBQQ8tKe4j2M50n3TC9Mf0dBlWGBkZZxjomOaZrzBrMnSwWLBOs/qzLbDnskuzdHN6cELxL9bnmuDN55HnGeJP5xPlG+A8ISAk8FTwqpCH0XviCiK0oVrRNLEZcXnxBolLSX0pM6r10rUykrIYcQq5fPk/BR1FJCak0qnxZJUHVRk1UbV19XKNR84RW0C5zbUkdvM4n3RG9ZuIl/QyDKEMvIytjAxMdUw0zZXMFC3lLeSuF3YrWqjZatkQ7M3t7B0/HEKck5xyXctdWt3H3pT2sezU9yV4nSG3eX33Efcl+l/xfUngDyUG1ISDUPezuPpmI8ijJ6NuxrvGYhHuJOQeCD3qkuKf5p6cdrcl8fpw92+lkwenhs8t5/PnWhekXu4qpSm3LSyp+VtnXNNazNCRee3XTuvn2bYk759upOxO7lnoP9G307xsYHhIaIT3JHq95emvq+vOSlwdnHF7xvn75Jv+d9fzGh5qPLp9Ri3VfXb6jlhp+kn4x/+5bTV0nbvkPCKABDWAG/EAOEOHVDwFHQCnoALMQGpKC7KBEOPsfR2AQCnBun4VoQSwg+ZAOyCxkF3IdpYmKRTWhltFa6GR0N4aAccKUwKuujT2OnaZSpsqgmsFp4c7jflG7U7fTiNFk0/zGB+AnCOaENlpV2no6abpqehn6RgZNhi5GW8YZpkhmKuZiFi14tePgDPM+ewyHCMcE53EuI6517ts8CbxavOt8XfzHBJwEhQS/CN0TzhUJEjUQ4xH7Lf5U4rbkRalYaWsZSVms7Du5Pvk6hTOKSUoUZWcVE1UNNVl1UQ1+TW4tzl1c2nw6IroyempEQ30HAz/DBKNs4xyTM6Z5ZhfNKywaLNus+nc/t/5ii7bjtldzsHUMd8pxbnQZc11zF/Ow3ZO8t95zhsTibUE+7HPXd8VfKyCRcjcIFWwZcjZ0Jlx+36GIkShxOCJNxanF5yYsJ3ok3UuWPpiXgkmNTfuQTjryNMMhc+iYzfHRbNec6VOUM9q5onlM+ciCXxe+Fn0u/lr66zLqCkuVZI1hnc/VI41Xr79sYrhlejvtTnc7TadD18Wel32sD40eBQwmDaWNJD8JGDd4Spjsexb9gvllyYzwbMFr7Jzfm7Z3hHn792c/DHxEfVL97L147MvVr6Pfvi0x/pD5abJM+rX/96mVytW7a2Pr77fWHwGffkYgAJ99c+ADn/wS0AMWIBaICIVDJdAYAo/QRUQjahHvkKJIX+QV5AJKCZWIuo9mRfuhb2FoMb6Yu1gubAJ859ShKsMRcPtxn6jJ1M9oXGjG8e74WUIIYZU2h06CroeewsDAcIcxjEmUaYa5hMWfVZF1ja2TPZPDkVOEc5lrgLuS5wgvhc+aX11AVJBNCC+MEUGKosWoxZklBCSVpCykKTIZsrVyo/KriqJKtsoHVKpVn6pTaahp+mqd3dWtvaQrqudCzNJvN/hhJG0cYFJl+tFcySLJsm83u3WgTZsds32IQ6+TsHOKy4ybgXv5HtzeMM8xko53pQ+rb6rftwBfSm+QQHBSyFTYrvDiCGxkWNRUjFlsS7xMQmkiV1JuMtPB0yksqfmHBdNrjqpl9GQ5HXt/4mAOx8nG08Qzt3NVzjWel8+/Vqh6obXI4NKjErfS+fKECsKV0iqt6rHayHrGq9cana+t37jcZNO81lLbureN8W5fR8q9XV3fe2ruBz9Q7YceDQxeGKKMKI0ujdVN7JlETRU+F31RNs02Ezvb/5p9zuZN6tvyd3fnH74f/HB/4c7H4k/pn10WxRe/f2n4GvpN5Nvj7/uXhJfu/HD6sfjz0DJu+eQvzl8Fvxl/Z65AK/Erc6tWqzfWeNYOr82vE9fz179tWG1c3lz/SD8lxa3wAeH1AUC/2Nj4JgoA9hQAayc3NlZKNjbWSuFk4xkA7cHb/ydtxRp6AAp7N1FP11X8v//L2f6v6R95zL/fYCsSbY3qmrftheCoBP4HawXuW+27sEAAAAA4ZVhJZk1NACoAAAAIAAGHaQAEAAAAAQAAABoAAAAAAAKgAgAEAAAAAQAAAKSgAwAEAAAAAQAAAJYAAAAA2U1RWgAAF9VJREFUeAHtXQt4FUWWruru+8iLhCAGYZAICRH4BFQUIYA4gM7uzH4y4mNwcX3Nig+GQUxAUDEzLggBBB+DOvuQcb8ZRz91GJ3d73NAV4cQRgWJIJgEcIKMPBIIeSf33u6uPXXJJTfJzX307UdVdxry3b7dVafOOfXfU1Wnqk5h1H/FrYHppZWFBOHpCKNpiJBL4D4TIZKFMR6ECOqA+waCcQMQPAP3BxHGu5FCtu9afvmJuAtxeELscPljij+ttPIHAMAlCOGbYibuKwEhhwG8uwGsHyse/M6ni/Ob+krq9Of9gIyAgHElB91ZaeJdGOGl8HpshCSaHxGCTgMwV5QX5W8FC0o0E7Jpxn5AhlXstGePDURi+yNgzRZhjHLCXhlwS/YiLC0sK8rbawBxbkn2A7Kz6gpLq6YDCN+Dr1lm1SaYRwL/fkOwuLy8OK/WrHJZLqcfkFA70E/8OXxsgCZUsqKyAJX1SEU3weBnjxXls1SmowEZ7CumSq+DZbzD8kqBUbqKyU/Kiy//o+W8WMiAYwE5fc3hwaqk/C+4bCZZqP/eRRO0qGxZwa96v3DGE8EZYnaX8upXiYtI6p+YAyNlE6OXCtdXlnbn2DnfHAlIb1PVi1Dx17JazeBuKoZ+7ZOs8mckX45rsgs3VN0N3r+tRipVD9rgr1TBgk8tKx79qR70eKHhKEBOWVd1rSCQMrBALk4q6DhRyTgYfTdzwm/SbDqmyZ6+qeYSEaM/cQRGWrnDoWvxWtK1zBEBxwCSBHwboXIHc1Q3QVah2Z43dX31vbzxrZVfRzTZUzd8M0IggRqtSrI6HyGkTZXw6N1LC76zmhejy3eEhcRqoNhoRRpJH6xkqqCgtUaWwQpt21tIumCCiO2noFLdrChdKx+KIFy1+7H8fVrz85DP9hZSFduX2gGMFEyCom7hAVTJ8GhrCznlueMpotz6HSyaGJiMkljKqxJ8a/my0e+wxJOevNjaQi4fVrzeTmCkFY+xupFOfeoJApZo2RaQ/o/Q5HbVO5MlZevBC/hRR6Q0VC/WgxaLNGwLSKK6Xt3ZMKuARaUnyxMR0Krg6vZkCTGY35aA9G8X78OEXPF16wRLFtwaXc/Q8R9ApI5fGl2OFfRtB0jyfygdFLm2PpDdFCAeK3RqSpkAyoemPHckz5TCTCzEdoD0K9Iq6PkPrlcGB0zUoxVFiaKsbLKiYCPLtBUgySdoOEYE9lAjdNo/1NYurSAoMPrR9NLD1xsJELNp2wqQfr/4IjhGgi6Rs4GL7dteh6GEIAVkts9lG0AGdiDYxopvDlWNC/vE0L2tPzG+AlaX32cXGW0BSFhdLahIeiW8Ury4XQ7/bu97vPbqkhOpdpDRFoAM7BAegQ7j2PAKSRHb7T6o6RIX1nl6UptWdD3g9457QIKbJwtG1b/oWQXZrjruZespU7TvAsbFhesqh0ZLw8M77istoIirYSDTa/HEpd6aFB4qQEcePUjA63SkZwkprgFJtqMxEBtnYSTNeYV2b5Z0NtIr2z6DbssCsJJsBT5IUNtcAzKAYSCDcZ+j6VzvkQTVwX9yLOCXeJaCW0DKO8S5oPgZ0ZQ/IWOPE+MvTp66vnJBNL2w/I5LQMJARlIIej6WYudkvd8aK40d30OllvLqBuISkLIsFIET/NJYYBrqPZ6e47b9Rr0IasCXeFObn4jwgvlH3AESrONFEOH2qXg1O2fg+/5409opHYQYfGza2qMxf7SsycwdIMHNQwOLxj0rcevFr3cIyEGTNl0I8xBR5m41EFeAhG0JE8DneHeXzmPfDZAaB9w0aJszrSRCt0zdUB114Bdbg+am4AqQSJFe1aKeB4dtbHeolUQCIS+jt0ifrjEt+jQyDzeA9G0X74TYPJO1KCNDbMr8h+x327TktUGesdO+rY44ecCibFwsYiXlKMXfKh6FkfUlWpXoI57muV/uyvARp80ogsYIOYeUlFFlK0ac06o/s/JxYSH9rdLKZMBIlenBvoyfDtsER7458IJACbxsCmPeQtJtCQG/eBhG1kmvAId1k/L8gzuk2oBmQ8szmhWMhfE7i/IPsSwE8xbSHxAhrmPyYKSVAL45aWVusVMPwhRVor7MMhgpb0wDMrgtAeHb9FTi+PR9Qyekf+5UN9AMCGtN1wAwezENyJ7bEvTS4qrcxxoFpOhFjis6AibPsxwbiFlA+neID0AHt9u2BL1qfqDr7OBbc15v1IseT3ToGoCUpip6yi2TF5ODGpivTocpwm8jrQTXS4sBVWqd99Vf0lqUTL1IckOHhogWZDF358r8OtaYZtJCAlh+aSQYaSW4BDntZ99bfZq1CjGDH7CSqaqkbjCjrETLYM5Ckg/RqIAqVsGQ2IzpLuXer98Tj3WMSlRvtkjPYoho5iykXxVfMAmMFFTi07lLHWklqfAshohmCpCBHdJsaE7+kSrLrCs35UjOjMwPfGaVx1I54Je9btr66juZ4okVZmj0CRhZVwEgTQ8x16KkN8w7sDMrQLg/qCHh6oQBzonTXnHkkcX5TPwombGQEH1isRVgpDWYLrZkLch5pSHh2rRBBtD50CE+dQUrojAxqAE3T1anmyfDKsUoRPDd8dVHnnqZu9Pn9FCZDw75HAmHfFo+rcqEhQzI4hpw81gGRlqjIlY9j136dK0etcshDQ9YSibcQJYDMhh9AqEHWKjEKZmfXDwm9UtnziliNL9w3eHrrK4HywEZK/qE2QqCeW7mF7EaphPB+pPCLAWkvF28GZTL1CakHM/Ji3446G1HBhiAAcWVhRuqEtpEp/ePw7JBDQxkJL8c3JbA3N7hDtXb8uP9ZenO3O6A6trbMnL3lgy1ZA+SZRYSok88Ch1p5sBIf/FeoSN94dCNzgqdFjJ1EPw0Ja1pZeir2Z+WWEgafQLcPN9YPbKOpmyHb3fwqdhVUF408lg0HRnxzhILCWB8lmUwUkV3bnc4ZYTSOaDpEVT/eiv4NB2Q56NPoPutEDbRMmG7w5DxaZ87Mg4L/CJvs8INZDogz0efAPvDybXqsqIGp253gLMttsCeblPrylRA+j4Ub9MafcIq/Ga7zlw0b/DrzVaVb2W5gETqBrrPTB5MQz85iNz+E+JhVkfW0ZQeIK7WeQc+ceR2B4jhXhfwCnmfLs5viqYjvd6ZZiHlU0Ixj2CkinbhQNqiYWvr9VI6V3TADeTqUEwLfmqKhQy6eWTxGHSU447ryGClEdjugJ243YEgEiDYnW+GG8gUCwmreWj0CZ7BSH8f+IncYkdaSQwHmgpqYLMZRsJwQAbdPBj/ixnCGF1GXkpV9ozMP6tGl8MkfYzmmnEUsuGA1BpklMlKAaaWXlrS6sKOjMSCCDbeDWToVlMaZBQGMotZBZcWvjyCz6MQ0fdly7WSlvyc5xk8fHf9qeN/fnGPUXIYNqjpdPPUACBtF/sOAOm/46sP3Y7c7gDBTwNeMdcoN5BhTbb/RPJBRo36FSZLV8SKe9Gw1Y5cMwmD04FSh1qSrA77ym+IhQQ3zxAYWdcA80kHGe2LcRaeP1z1BqpsG88CK6byQN1AqiiN3b00T/fDJA2xkLCaZ5PdwUgRsGLECkdaSeoGEhXFEDeQ7oD0b0ewUQj/xNSfrEWFDffWpM0Z9J5FpVte7A8h+OksvbnQHZAIScyHDdZTiQ8PLW2TcEBPktzQEgT0it5n4OgKSP+H4j2wmmciNxrVgdFM6Vzq/Jxfm7LwQAd2dSUBA5C8wmPVD+lJVLdBDdmDUv0NsGkL4SF6MsgDLZXg5lkVBwIgezYP/OrMY4M/oOZ9tnKMLnuQdLOQ/gbpSSeCkVYuxmQzwoJpK2J0BlSy5LJcLqEkWSKh/LpYSD3PkgkxxssnRA876U5TRk06QGRvU/Uh2ozxwruOfOp2Bo4uFhLOknGEmydiBWK0FE9F7XsX4gAm+NGIaez/UCSqskUPMZO2kPQsGYKkv+jBDIc0PnfPlq8N57uwtPIDmC69MfyZU+4hgtrNEEEtKT9Y0haSEOkFpyi8l5yq3CtIlipJj0A6ZwasEtALyZ6BkxQg/dvF+5zm5ukCJfm1+0ZU0fX9/B2dToMgA7o0Xz1ps/4dBrUjvE2HlyTDp2ZA0iODoeC1yRTOb17S7CLKsr74x4r36eCRwH0lsPVz8uT0NYc1R33VDEg4MngV+Ds0F8x3nZCn8BzU50lg58+lxk/xLaM27mFQMkB1qRCZRNulaVATdPMExKPggXNpK5bfXNAcV8JAZhyEOoi+leEtIk47Vr0fJB3Lr7TaOCdwZLwqCFfvfix/X6IUNFnIoJvHgWCkyhUw+llMMNKEt2MFE+Fheuu0C6wc1noGTsKA7DwyeJ7TlEzlBSf4e67Z8o54Zd+5LP8Tmife9HZKBz/a6wrXV96eqEwJA9KoI4MTZdz89CTgFpSliZZLBPdiuqA10Xy2SE/QprwXDie0SDuhjUrg5vlXUFTMPlEzcaGKwCB0UB7Y5CNiU42SJp9U00Rqyl1I9dC/a9x12I3VjCtdZ1Ce2IQyGF/CBTGXnsezEfSbE7vo5nqwFHQxa3FiOflPDRMEQ3N8yjJYVv5MvNLEPaiBbQnpsC3hm75G1nsCgxrfbx9xZm9gUEo9SRkaLwOhdMOElsbZ3pPSDZ7v0kYDQJm6CKlzScpIfANq0cLX5BcOD3B1qEfAZ+s4rwR0WdogPlB+vGfgxA1I33ZpPfQLinpWyNvtuce3tI3xdhCXbsoeIrSevTetOuWfPMfZiHZByAPuOcq/95Q9ke9gJe8Hx/F/JJLHLmkBlL/dtezyBfHIExcgyQ40MoCkbs3Vi23jTr3VlpuhIDEtnoK0pEnBgbpH0g8pt3iOWbnGcj+4eSZo4b9bHmjzCzdU7wWFX9ntuUO+gB9oyq7l+X+NJW5cgxo/EZ8LEaqSM3w/qr/x72+0jRpiJBhpee1gdTc0Txhy89k5p78IZCshHsz8xEhepEt5sGgSqc50AwX1F+cZODEtZPhqnpdax9X+rn3UxbpUkAYid6YcPb0o7WCOhqyassDo+B3PbOVWTZn7yFS4vupNUHrC7pA+yPH1mKC7y5YVvB6N6ZgWEpaWvURHzXPrZ9dZCUYqBJSfc1v99xspP2ZcbpK4mycWXwS76Bw4E0cBx+JV7/fwA3/26pITUccFUQHp3yEsrFYGjL/l3Kz6WjVVt0FLMoJ+p6Zn3nNuxjngKxkyMfPC9NcamK/+NmbCBBNQN5BKiCUnHCTIqu7JqRso1hk4fTbZpAxl7G/JrnmwYXpKAIl0ZQ9TlwfLvlezyjyGuIgIqXWp4Oa5CbUaITS1Et7UJhreOmH3mBH8mEwz6hk4fVrIt85d9m8PNMxwswhGqkAfkTwLz03zG9R8rzAKjJR3emwbnG2wnN478PIIxN/nUcgRLeTEN+bmihjvA79ZFusKGy60tLyZ/VG6XnxCU33IA6t59KIXjU5hadVuOucbLY1d38HCk5l0rr+nfBEtpITxazyAkQpzXE1Pf7Z5fENPwbR+F5D8oNa8ieZTRee6gfoKftoLkFe9ccs9MOU8M1HlWpn+fV9u1hf+7OjrE+NgkLp5XLPRzjiS6pKkc73gf+tCjD8iY6duqP5pT7a7AXLiH+Zmgf92U89EPHx/ovkaTfPMXbLBah6XYvo2Vtip93hwvreLEcfcCQStpvP84QJ3A6TUISzhpakOF4LeNxLPgJdbLtcMSoLwBnw9Ot6TrtHfzy86wKuNLodJ+vQMHFgNFM5bN0ASTH4e/pK3+993jBI1jbphNY87VX7GKnlPe4WN0F04ZlX5VpYLg8iHwtdMXgAk7Tvyah1DCqUuqo98l2jxHS6n0SdCdMz+PLI430ew2Gslldl8WFEeYC47p0O9K1T2BUBC3/Hp0EOeP7e0jpET4p+gClha9lpCeQxIXF6U/zbskejlBjGgKOZIguvrQt89CMhO65jLHKcaGGomnsyEphUFeaGGYgzJggXxYWjC4L/jrrFT11d+n0odBKSAyd12UsE77ZfVxycPedM9C30WX1rjU+0syj8Ei9SSWghsPJfGlCAgHNw42Nlk45nGFGMN1b/6B8dutgnxQeT2pMJ+GCKd4n0cTCRjezgMkbQHUTKZPhAmvTF3Zo833H+tU1NjrtkkGJfCHplTrAlLo14AIH/BGl9G8wML6q+kgaoEFQm5RhdmBf19sOuxrwtcLKfAzaM53EdfdPV67hsw+kUA5RG96PFABwY2Qmpj1bUQSB/l8sBwojx+FRgYzUleZKWbJ5YsNPgpOOrZ607EYjzJ9xCGdzLgkcxMkg6T2WsVb20fjH0O2xJ+28c7Zh6XF4/+H6ibD5hhyARGMCJXC7Aub4QJZZleRD3yRtgmALPGRL7fdGY0FqiIEt1gZsnmNo0sJ5kNfw9iJ+HcJKkwmf1vcnrvtZwEveqZgw4wyXAEpmjwU9ju8FKEV/Z8RNCATrePLeXrsRyNNLiQ8jhvkipecRWYdV3OgOFAdpdtAZmClR6+SPJEtCCjrFYWPZcaRtxPscqfznw12xaQBVJjR0hZ54OMqltC33n7LC8ueAV4PsQb3xr4rRfsOqHvRsqFEC+CwM9AJmIlwsoXRwQ/xaiejrJ1248SUZkWPRwo+js3pJPfu2ahcovY0K3Yzg1Rf9CNIIOEMEJHYV0FrmCQt6RZukI6OxCsfxvMV19Y2pQ0UYsJqNj1KMwy2Tf4KcF7oA+pfmyxng0p/ipXPezDJ6tZnK/WKjCNeoEI3qg1P+v5VCx8Jsje3of/sM54LP4uEtpqwVVyXBLV0lhpeXvf0ZbxDKyYrOON71j8gifhu/LivFqh4sfbGqAZ+DJWBp7eX+M6o4gCegSsYw/XD09SROaVRr1QEe62MSpySr6ewjpQmCrtXKAL/chtfLEfndtxrvpvpFnK+9FT8fu2fNnorWBR9vErQW/OoUULLkwO+iFlpG7tnYTfJxdJ6Sv45T5Ozm0U/BT8xAdhO/AeKnkQkBXzt9VAs/3HOFXBdDL4pf1m9g/272SaSR2Yo+GRoc5+pwMpy0lgoeuw0q6ZGky2Ws5ZkgxAM9aoIFKSJBl+sqvBo0YirGriRwTg1NfekrE1xPEFQO69Y9s23gc30DHeTK19SDi7f3ZGvXiGZzmhuV5DB2ohGS4Akj7AhCwJveDtEwQ7JnvVzbzxnSy/Umv+OqCxP1k6FuU/5GobvSa87G6A3DN/28dgJZ8PT8DLPRzOeg91YfHCr158flyCZQWjO6Dv7NeLphl0oHsFcbbwP1P+w8vrBkj6QvGQEtoXC0/E+j39EdEfE+t8GsXf7qKCSmjfHjeKvjF08fPgvqroSbsXIKmVUQR1Zs+ErH6n/V76I2KVP7P42rWsYBN0W/jwLhD0tSqmrIykm16ApIkqbt9WoRJ0b6QMLD0Ljqo9ZKYTm+pI9SDIwjzQCVhLdi/g7wiWhet3Lx0eMbhXREBScb6Y/+5WlkEZBCNY8n4wdoFv58r8OiEgzGAVlNDPrfET93TKZxfX3e/6BCRNRkGJCHtRFC6AESx5d3H6v4WB8ghT2iDo7zIRp3++7LKo0UJgTWTsKxgdDaPNkDgzdmpjU/SDMT79XlP6tyFu7N8JdZYXXw7jUkGdlcku162fLhl5OlYpUS1kKDO1lHSgQ319oWdWfAYHMESdSPu4VpTPU5nUEnUo0iRYpPxfFvJN95SX7GodfX08YKR8xmUhQwLRoPiiD2+Fvdw3h56Z9gldhz3z3y0xrTwbFVS4rvIGWLVAj3oZYZ5Y5CTC+PayooKyRMpMCJAhwucjpuESKPD60DPDPiGqrCySJf1WMTkNT3nueIqotK4FG7Q4OUqxc0MT/Z9Y9hbTSG6xU3dPoQmQIRLn+5aEntwwIfRMt89geGNS4mSHt266DCM0Y+OR4Yqi3AUVvwDaxzFhr5K8JScBiC93YPzy3qKCM1qJJQXIUKET35o7UVTxPbDfYy6EVdPcLAT7qJhsUwSytd8ihrRr3Cc05ZNg1+kCiF57YxLg/BTqbRM45t/Ug1NdABnOSBCcBOViVZgIm4knwgqcrJ5NOwUeRLqqOZ8Pf0wEtQLmY2v6QRiuSXPvZ/6qNl1ua5ykIvUqGOkOg6lm2LWJB8JAMhNAEhz8ggWE8DT4KOyeO6Co5CBype4DB3ec4bPjk+f/AQiWaA0qPjbOAAAAAElFTkSuQmCC"/>
              </defs>
              </svg>

              <div class="pt-6 pb-3">
                <strong class="text-lg">Google Ads</strong>
              </div>

              <p class="pt-3" style="color: rgba(0, 0, 0, 0.6); line-height: 25px;">
                View KPI's by campaign, ad group, keywords, ads and conversions for your clients' Google Ads and Local Service Ads account.
              </p>

              <!-- <v-chip
                v-if="me.integrations.google_ads.status == 1 && me.integrations.google_ads.settings.selected_manager_id"
                class="mt-2"
                small
                color="green lighten-5"
                text-color="green lighten-1"
                @click="saved = false"
              >
                <i class="mdi mdi-checkbox-marked-circle-outline mr-1"></i>
                Connected
              </v-chip>

              <v-chip
                v-else
                class="mt-2"
                small
                color="red lighten-5"
                text-color="red lighten-1"
                @click="saved = false"
              >
                <i class="mdi mdi-close mr-1"></i>
                Not Connected
              </v-chip> -->
            </div>
          </div>

        </div>

        <div class="bg-gray-100 rounded-b-lg px-6 py-4">

          <div v-if="me.integrations.google_ads.status == 1">

            <button v-show="me.integrations.google_ads.settings.managers.length > 0" class="rg-dialog-button-save rounded text-white text-xs text-bold focus:outline-none py-2 px-4 float-right" :class="{'spinner': savingGoogleAds}" @click="saveGoogleAdsSettings();">
                SAVE
            </button>

            <button class="rounded text-blue text-xs text-bold border border-blue focus:outline-none py-2 px-4 mr-2 float-right" @click="show_google_ads_popup = false">
                CLOSE
            </button>
          </div>
          <div v-else>
            <button class="rg-dialog-button-save rounded text-white text-xs text-bold focus:outline-none py-2 px-4 float-right" :class="{'spinner': savingGoogleAds}" @click="connectGoogleAdsAccount">
                CONNECT ACCOUNT
            </button>

            <button class="rounded text-blue text-xs text-bold border border-blue focus:outline-none py-2 px-4 mr-2 float-right" @click="show_google_ads_popup = false">
                CLOSE
            </button>
          </div>

          <div class="clearfix"></div>

        </div>

      </div>
    </div>
    
    <div v-if="show_stripe_popup" @click.self="show_stripe_popup = false" class="fixed top-0 left-0 h-full w-full z-50 flex flex-column items-center justify-center" style="background-color: rgba(0,0,0,.2);">
      <div class="w-full sm:w-1/2 lg:w-2/5 bg-white rounded-lg mx-6">

        <div class="rg-modal-header">
          Stripe Settings

          <a href="javascript: void(0);" class="rg-modal-close-btn" @click="show_stripe_popup = false"><i class="mdi mdi-close"></i></a>
        </div>

        <div class="p-6" style="position: relative;">

          <div class="float-right -mb-4" style="position: relative;">
            <!-- <a href="https://www.bland.ai/" class="text-xs" target="lsa-bland-link">Sign Up for Bland</a> -->
          </div>

          <div style="clear: both;"></div>

          <div class="flex flex-row flex-wrap">
            <div :class="'w-full mb-3'">
              <!-- <div class="float-right -mt-1">
                <a href="https://www.loom.com/share/1d4766de85df4e90a1f550af06a76cf0?sid=b378d08b-ca15-4fe4-8d8b-c2970a5aa11d" style="font-size: 12px;">How to create CallRail API Key?</a>
              </div> -->
              <p class="mb-1 text-xs mb-2"><strong>Publishable Key</strong></p>
              <input :type="text" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded"  v-model="me.integrations.stripe.settings.publishable_key" style="padding-right: 35px !important;"
                :class="(($vuetify.breakpoint.xs) ? 'mb-2' : '')"

                data-lpignore='true' autocomplete='off'
              />
            </div>

            <div :class="'w-full mb-3'">
              <!-- <div class="float-right -mt-1">
                <a href="https://www.loom.com/share/1d4766de85df4e90a1f550af06a76cf0?sid=b378d08b-ca15-4fe4-8d8b-c2970a5aa11d" style="font-size: 12px;">How to create CallRail API Key?</a>
              </div> -->
              <p class="mb-1 text-xs mb-2"><strong>Secret Key</strong></p>
              <input :type="((show_stripe_secret_key) ? 'text' : 'password')" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded"  v-model="me.integrations.stripe.settings.secret_key" style="padding-right: 35px !important;"
                :class="(($vuetify.breakpoint.xs) ? 'mb-2' : '')"

                data-lpignore='true' autocomplete='off'
              />

              <a href="javascript: void(0);" @click="show_stripe_secret_key = !show_stripe_secret_key" class="token_password_toggle">
                <i v-if="show_stripe_secret_key" class="mdi mdi-eye-outline"></i>
                <i v-if="!show_stripe_secret_key" class="mdi mdi-eye-off-outline"></i>
              </a>
            </div>
          </div>

          <div v-if="stripeSettingsError" class="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 mb-4 mt-1" role="alert">
            <div v-html="stripeSettingsError"> </div>
          </div>

          <!-- <v-chip
            v-if="me.integrations.bland.status == 1"
            class="mt-2"
            small
            color="green lighten-5"
            text-color="green lighten-1"
            @click="saved = false"
          >
            <i class="mdi mdi-checkbox-marked-circle-outline mr-1"></i>
            Connected
          </v-chip>

          <v-chip
            v-else
            class="mt-2"
            small
            color="red lighten-5"
            text-color="red lighten-1"
            @click="saved = false"
          >
            <i class="mdi mdi-close mr-1"></i>
            Not Connected
          </v-chip> -->

        </div>

        <div class="bg-gray-100 rounded-b-lg px-6 py-4">

          <button class="rg-dialog-button-save rounded text-white text-xs text-bold focus:outline-none py-2 px-4 float-right" :class="{'spinner': savingStripeSettings}" @click="saveStripeSettings">
              SAVE
          </button>

          <button class="rounded text-blue text-xs text-bold border border-blue focus:outline-none py-2 px-4 mr-2 float-right" @click="show_stripe_popup = false">
              CLOSE
          </button>

          <div class="clearfix"></div>

        </div>

      </div>
    </div>
    
    <div v-if="show_smtp_popup" @click.self="show_smtp_popup = false" class="fixed top-0 left-0 h-full w-full z-50 flex flex-column items-center justify-center" style="background-color: rgba(0,0,0,.2);">
      <div class="w-full sm:w-1/2 lg:w-2/5 bg-white rounded-lg mx-6">

        <div class="rg-modal-header">
          SMTP Settings

          <a href="javascript: void(0);" class="rg-modal-close-btn" @click="show_smtp_popup = false"><i class="mdi mdi-close"></i></a>
        </div>

        <div class="p-6" style="position: relative;">

          <div class="float-right -mb-4" style="position: relative;">
            <!-- <a href="https://www.bland.ai/" class="text-xs" target="lsa-bland-link">Sign Up for Bland</a> -->
          </div>

          <div style="clear: both;"></div>

          <div class="flex flex-row flex-wrap">
            <div class="w-full lg:w-1/2 pr-3">
              <p class="mb-1 text-xs mb-2"><strong>From Name</strong></p>
              <input type="text" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" v-model="me.integrations.smtp.settings.from_name"  />
            </div>
            <div class="w-full lg:w-1/2 pl-3">
              <p class="mb-1 text-xs mb-2"><strong>From Email</strong></p>
              <input type="text" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" v-model="me.integrations.smtp.settings.from_email"  />
            </div>
            <div class="w-full lg:w-1/2 pr-3 mt-3">
              <p class="mb-1 text-xs mb-2"><strong>Username</strong></p>
              <input type="text" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" v-model="me.integrations.smtp.settings.username"  />
            </div>
            <div class="w-full lg:w-1/2 pl-3 mt-3" style="position: relative;">
              <p class="mb-1 text-xs mb-2"><strong>Password</strong></p>
              <input :type="((show_smtp_password) ? 'text' : 'password')" data-lpignore="true" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" v-model="me.integrations.smtp.settings.password" style="padding-right: 35px !important;" />

              <a href="javascript: void(0);" @click="show_smtp_password = !show_smtp_password" class="token_password_toggle">
                <i v-if="show_smtp_password" class="fa fa-eye"></i>
                <i v-if="!show_smtp_password" class="fa fa-eye-slash"></i>
              </a>
            </div>
            <div class="w-full lg:w-1/2 mt-3 pr-3">
              <p class="mb-1 text-xs mb-2"><strong>Host</strong></p>
              <input type="text" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" v-model="me.integrations.smtp.settings.host"  />
            </div>
            <div class="w-full lg:w-1/2 pr-3">
              <div class="flex flex-row flex-wrap">
                <div class="w-full lg:w-1/2 mt-3 pl-3">
                  <p class="mb-1 text-xs mb-2"><strong>Port</strong></p>
                  <input type="text" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" v-model="me.integrations.smtp.settings.port"  />
                </div>
                <div class="w-full lg:w-1/2 mt-3 px-3 pl-10">
                  <p class="mb-1 text-xs mb-2"><strong>SSL/TLS</strong></p>

                  <v-checkbox
                    class="mt-4"
                    label="Enabled"
                    value="yes"
                    hide-details
                    v-model="me.integrations.smtp.settings.ssl_tls"
                      :ripple="false"
                  ></v-checkbox>
                </div>
              </div>
            </div>
          </div>

          <div v-if="errorSMTP" class="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 mb-4 mt-1" role="alert">
            <div v-html="errorSMTP"> </div>
          </div>

        </div>

        <div class="bg-gray-100 rounded-b-lg px-6 py-4">

          <button class="rg-dialog-button-save rounded text-white text-xs text-bold focus:outline-none py-2 px-4 float-right" :class="{'spinner': savingSMTP}" @click="saveSMTPSettings">
              SAVE
          </button>

          <button class="rounded text-blue text-xs text-bold border border-blue focus:outline-none py-2 px-4 mr-2 float-right" @click="show_smtp_popup = false">
              CLOSE
          </button>

          <div class="clearfix"></div>

        </div>

      </div>
    </div>

    <div v-if="show_ww_example_popup" @click.self="show_ww_example_popup = false" class="fixed top-0 left-0 h-full w-full z-50 flex flex-column items-center justify-center" style="background-color: rgba(0,0,0,.2);">
      <div class="w-full sm:w-1/2 lg:w-2/5 bg-white rounded-lg mx-6">

        <div class="rg-modal-header">
          White Label Asset Example

          <a href="javascript: void(0);" class="rg-modal-close-btn" @click="show_ww_example_popup = false"><i class="mdi mdi-close"></i></a>
        </div>

        <div class="p-6" style="position: relative;">

          <img v-if="ww_asset == 'desktop'" src="@/assets/images/ww_examples/ww_example.png" />
          <img v-if="ww_asset == 'mobile'" src="@/assets/images/ww_examples/ww_example_logo.png" style="max-height: 700px;" />
          <img v-if="ww_asset == 'favicon'" src="@/assets/images/ww_examples/ww_example_favicon.png" />

          <div style="clear: both;"></div>
        </div>

        <div class="bg-gray-100 rounded-b-lg px-6 py-4">

          <button class="rounded text-blue text-xs text-bold border border-blue focus:outline-none py-2 px-4 mr-2 float-right" @click="show_ww_example_popup = false">
              CLOSE
          </button>

          <div class="clearfix"></div>

        </div>

      </div>
    </div>

      <!-- <div class="float-right ml-5 -mt-1">
        <div class="border-1 border-blue text-primary text-xs text-bold px-4 py-2 rounded cursor-pointer float-right" @click="openGuide()" style="margin-top: -5px;"><i class="fa fa-link mr-2"> </i> GETTING STARTED GUIDE</div>
      </div> -->
      
      <div class="flex flex-row items-top justify-between">
        <h1 class="text-lg font-semibold mb-3">Settings</h1>
        <!-- <div class="bg-green-500 hover:bg-green-400 text-white inline-block rounded py-2 px-3 cursor-pointer" :class="{'spinner': saving}" @click="save">Save</div> -->
      </div>
      
      <hr class="border-b border-gray-100 mb-3">

      <div class="dashboard-box" v-if="me">
        <v-card
          class="pa-2"
          tile
        >
          <div class="p-3 pt-1">

            <template>
              <div v-if="profile.settings.role == 'Manager (readonly)'">
                You do not have permission to change the settings of the agency. Contact your account owner.
              </div>
              <v-tabs v-else>
                <v-tab>Main Settings</v-tab>
                <v-tab>White Label</v-tab>
                <v-tab>Integrations</v-tab>
                <v-tab>Customer Lead Notifications</v-tab>
                <v-tab>AI Fixes Log</v-tab>
                <v-tab>Version History</v-tab>

                <v-tab-item class="pt-5">
                  <div class="flex flex-row flex-wrap -mx-3">
                    <div class="w-full lg:w-1/3  px-3">
                      <p class="mb-1 text-xs mb-2"><strong>Agency Name</strong></p>
                      <input type="text" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded"
                      v-model="me.company_name"  />
                      <p class="text-xs text-gray-500 mt-2">This will also replace "Reviewgrower" all over the app.</p>
                    </div>
                    <div class="w-full lg:w-2/3  px-3" :class="(($vuetify.breakpoint.mobile) ? 'pr-0' : '')">
                      <div class="flex flex-row flex-wrap -mx-3">
                        <div class="w-full lg:w-1/2  px-3" :class="(($vuetify.breakpoint.mobile) ? 'pr-0' : '')">
                          <p class="mb-1 text-xs mb-2"><strong>Privacy Policy Link</strong></p>
                          <input type="text" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" v-model="me.integrations.stripe.settings.privacy_policy_link" placeholder="https://"  />
                        </div>
                        <div class="w-full lg:w-1/2 pl-3" style="position: relative;">
                          <p class="mb-1 text-xs mb-2"><strong>Terms of Service Link</strong></p>
                          <input type="text" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded" v-model="me.integrations.stripe.settings.terms_of_service_link" placeholder="https://" />
                        </div>
                      </div>

                      <p class="text-xs text-gray-500 mt-2">Your Privacy Policy and Terms of Service links are used to generate your customer portal in Stripe.</p>
                    </div>
                  </div>

                  <hr class="mt-4 mb-4">

                  <div class="w-full">
                    <div class="w-full">
                      <p class="mb-1 text-xs mb-2"><strong>Permissions</strong></p>
                      
                      <v-checkbox
                         :ripple="false"
                        v-model="me.settings.signup_link"
                        label="Enable signup"
                        hide-details
                      ></v-checkbox>
                    </div>

                    <div v-show="me.settings.signup_link == 0" class="w-full mt-3">
                      <p class="mb-1 text-xs mb-2"><strong>Signup Page</strong></p>
                      
                      <v-checkbox
                         :ripple="false"
                        v-model="me.settings.signup_page"
                        label="Allow opening the signup page directly"
                        hide-details
                      ></v-checkbox>
                    </div>

                    <div v-show="me.settings.signup_link == 0 && me.settings.signup_page == 0" class="w-full mt-3">
                      <p class="mb-1 text-xs mb-2"><strong>Stripe Plams</strong></p>
                      
                      <v-checkbox
                        :ripple="false"
                        v-model="me.settings.allow_stripe_plans_signups"
                        label="Only Allow Signup for Stripe Plans"
                        hide-details
                      ></v-checkbox>
                    </div>

                    <!-- <hr class="mt-3" /> -->
                  </div>

                  <div v-show="false" class="w-full mt-4">
                    <p class="mb-1 text-xs mb-2"><strong>Contacts Webhook</strong></p>

                    <p class="text-xs text-gray-500">Select which webhook your customers will use for adding contacts.</p>
                    
                    <v-radio-group
                      class="mt-2"
                    v-model="me.settings.contacts_webhook"
                    >
                      <v-radio
                        :label="getExternalContactFormLink()"
                        value="regular"
                        on-icon="mdi-circle"
                        off-icon="mdi-circle-outline"
                        :ripple="false"
                      ></v-radio>
                      <v-radio
                        :label="getExternalContactFormLinkWhiteLabeled()"
                        value="white_labeled"
                        on-icon="mdi-circle"
                        off-icon="mdi-circle-outline"
                        :ripple="false"
                      ></v-radio>
                    </v-radio-group>
                  </div>

                  <hr class="mt-4 mb-4">

                  <div class="w-full">
                    <p class="mb-1 text-xs mb-2"><strong>Custom CSS</strong></p>
                    
                    <textarea name="" id="" rows="14" class="text-sm block appearance-none focus:outline-none focus:border-gray-500 w-full bg-gray-100 hover:border-grey px-4 py-4 rounded" maxlength="1000" v-model="me.settings.custom_css" placeholder="/* Example */
header {
    background-color: purple !important;
}

nav.v-navigation-drawer {
    background-color: purple !important;
}

.me-icon {
    background-color: #b794f4 !important;  
}" ></textarea>

                    <!-- <p class="text-xs text-gray-500 mt-2">Enter custom CSS to change the UI of the app. <a href="https://reviewgrower.com/documentation/how-to-customize-your-user-interface-using-custom-css/" target="custom-css-documentation">Custom CSS Documentation</a></p> -->
                  </div>

                  <hr class="mt-3" />

                  <div class="float-right mt-6">
                    <div class="bg-purple text-white text-sm inline-block rounded py-2 px-3 cursor-pointer" :class="{'spinner': savingAgencySettings}" @click="saveAgencySettings()">Save</div>
                  </div>
                </v-tab-item>
                <v-tab-item class="pt-5">
                  <div class="flex flex-row flex-wrap -mx-3">
                    <div class="w-full mb-4 px-3">
                      <div class="bg-gray-100 rounded p-4">

                        <h2 class="font-bold text-sm text-gray-800 mb-4">Domain</h2>

                        <a href="javascript: void(0);" v-if="!show_subdomain_field" @click="show_subdomain_field = true" style="font-size: 17px;">{{ me.domain || '- none, click here to setup -' }}</a>

                        <input type="text" ref="domain" v-if="show_subdomain_field === true" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white border hover:border-grey px-2 py-2 rounded" placeholder="e.b. mydomain.com" style="width: calc(100% - 100px); display: inline-block; margin-right: 10px;"  />

                        <div v-if="show_subdomain_field === true" class="bg-purple text-white inline-block rounded py-2 px-3 cursor-pointer" :class="{'spinner': savingDomain}" @click="saveDomain()">Save</div>

                        <div v-if="errorDomain" class="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 mb-4 mt-1" role="alert">
                          <div v-html="errorDomain"> </div>
                        </div>

                        <div class="flex flex-row flex-wrap -mx-3 mt-3" style="font-size: 13px;">
                          <div class="w-full sm:w-1/3 px-3">
                            <div class="">
                              DNS Settings:
                              <div class="mt-2">
                                <!-- <strong>CNAME:</strong> dns.accelerateyourmarketing.com
                                <br /> -->
                                <strong>A Record:</strong> 34.200.70.126
                              </div>
                            </div>
                          </div>
                          <div class="w-full sm:w-1/3"
                            :style="(($vuetify.breakpoint.mobile) ? 'padding-left: 11px; padding-top: 11px;' : '')"
                          >
                            <p class="" style="margin-bottom: 0px;">
                              Domain Status: 
                            </p>

                            <div v-if="!me.domain">
                              <i class="fa fa-exclamation-circle" style="color: orange; font-size: 24px;"></i>
                              <br />
                              <p class="0">
                                No domain setup <i v-if="me.domain && (me.domain_status == 0 || me.ssl_status == 0)" class="fa fa-spin fa-spinner" style="margin-left: 4px; font-size: 14px;"></i>
                              </p>
                            </div>

                            <div v-if="me.domain && me.domain_status == 0">
                              <i class="mdi mdi-close-circle" style="color: red; font-size: 24px;"></i>
                              <br />
                              <p class="0">
                                Check DNS settings <i v-if="me.domain && (me.domain_status == 0 || me.ssl_status == 0)" class="fa fa-spin fa-spinner" style="margin-left: 4px; font-size: 14px;"></i>
                              </p>
                            </div>

                            <div v-if="me.domain && me.domain_status == 1">
                              <i class="mdi mdi-check-circle-outline" style="color: green; font-size: 24px;"></i>
                            </div>
                          </div>
                          <div class="w-full sm:w-1/3"
                            :style="(($vuetify.breakpoint.mobile) ? 'padding-left: 11px; padding-top: 11px;' : '')"
                          >
                            <p class="" style="margin-bottom: 0px;">
                              SSL Status: 
                            </p>

                            <p class="" style="display: inline-block;">
                              <i v-if="me.ssl_status == 1" class="mdi mdi-check-circle-outline float-left" style="color: green; font-size: 24px;"></i>
                              <span v-if="me.ssl_status == 1" class="float-right mt-2 ml-2">expires {{ formatDate(me.ssl_expiration) }}</span>
                              <i v-if="me.ssl_status == 0" class="mdi mdi-close-circle" style="color: red; font-size: 24px;"></i>
                              <span v-if="me.ssl_status == 0 && me.domain_status == 1">&nbsp;&nbsp;(please check later)</span>
                              <span v-if="me.ssl_status == 0 && me.domain_status == 0">&nbsp;&nbsp;(check DNS Settings)</span>

                              <i v-if="me.domain && (me.domain_status == 0 || me.ssl_status == 0)" class="fa fa-spin fa-spinner" style="margin-left: 5px; font-size: 14px;"></i>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="w-full px-3"  :class="(($vuetify.breakpoint.mobile) ? 'pl-4' : '')">
                      <div class="" >

                        <single-lead-notification-settings />
                          <div class="float-left" style="width: 250px; max-width: 100%;">
                          <strong class="text-sm">Agency Logo <a href="javascript: void(0);" @click="show_ww_example_popup = true; ww_asset = 'desktop'" style="font-size: 12px; marign-left: 10px;">View Example</a></strong>
                          <br />

                          <v-file-input
                            accept="image/*"
                            v-model="file"
                            @change="onUpload"
                            class="rg-uploader"
                            prepend-icon="mdi-camera"
                            outlined
                            hide-input
                          ></v-file-input>

                          <div v-if="me.logo" style="padding-top: 0px;">
                            <span v-if="me.logo" style="text-align: center;">
                              <img :src="me.logo" alt="" style="display: inline-block; max-height: 40px; margin-right: 20px; border: solid 1px #CCCCCC; padding: 2px;">
                              <v-btn
                                depressed
                                color="error"
                                icon
                                small
                                @click="me.logo = ''; removeLogo()"
                              >
                                <i class="mdi mdi-trash-can-outline" style="font-size: 20px;"></i>
                              </v-btn>
                            </span>
                          </div>

                          <i v-if="uploading" class="fa fa-spin fa-spinner" style=""></i>
                        </div>

                        <div class="float-left" style="width: 250px; max-width: 100%;">
                          <strong class="text-sm">Agency Mobile Logo <a href="javascript: void(0);" @click="show_ww_example_popup = true; ww_asset = 'mobile'" style="font-size: 12px; marign-left: 10px;">View Example</a></strong>
                          <br />

                          <v-file-input
                            accept="image/*"
                            v-model="file_mobile"
                            @change="onUploadMobile"
                            class="rg-uploader"
                            prepend-icon="mdi-camera"
                            outlined
                            hide-input
                          ></v-file-input>

                          <div v-if="me.settings.logo_mobile" style="padding-top: 0px;">
                            <span v-if="me.settings.logo_mobile" style="text-align: center;">
                              <img :src="me.settings.logo_mobile" alt="" style="display: inline-block; max-height: 40px; margin-right: 20px; border: solid 1px #CCCCCC; padding: 2px;">
                              <v-btn
                                depressed
                                color="error"
                                icon
                                small
                                @click="me.settings.logo_mobile = ''; removeLogoMobile()"
                              >
                                <i class="mdi mdi-trash-can-outline" style="font-size: 20px;"></i>
                              </v-btn>
                            </span>
                          </div>

                          <i v-if="uploading_mobile" class="fa fa-spin fa-spinner" style=""></i>
                        </div>

                        <div class="float-left" style="width: 250px; max-width: 100%;">
                          <strong class="text-sm">Agency Favicon <a href="javascript: void(0);" @click="show_ww_example_popup = true; ww_asset = 'favicon'" style="font-size: 12px; marign-left: 10px;">View Example</a></strong>
                          <br />

                          <v-file-input
                            accept="image/*"
                            v-model="file_favicon"
                            @change="onUploadFavicon"
                            class="rg-uploader"
                            prepend-icon="mdi-camera"
                            outlined
                            hide-input
                          ></v-file-input>

                          <div v-if="me.settings.favicon" style="padding-top: 0px;">
                            <span v-if="me.settings.favicon" style="text-align: center;">
                              <img :src="me.settings.favicon" alt="" style="display: inline-block; max-height: 40px; margin-right: 20px; border: solid 1px #CCCCCC; padding: 2px;">
                              <v-btn
                                depressed
                                color="error"
                                icon
                                small
                                @click="me.settings.favicon = ''; removeFavicon()"
                              >
                                <i class="mdi mdi-trash-can-outline" style="font-size: 20px;"></i>
                              </v-btn>
                            </span>
                          </div>

                          <i v-if="uploading_favicon" class="fa fa-spin fa-spinner" style=""></i>
                        </div>

                        <div class="float-left" style="width: 250px; max-width: 100%;">
                          <strong class="text-sm">LSA Audit</strong>

                          <br />

                          <v-checkbox
                            :ripple="false"
                            v-model="me.settings.audit_show_agency_name"
                            class="mt-2"
                            label="Show agency name"
                            hide-details
                          ></v-checkbox>

                          <br />

                          <v-checkbox
                            :ripple="false"
                            v-model="me.settings.audit_show_agency_website"
                            label="Show agency website"
                            hide-details
                          ></v-checkbox>

                          <br />

                          Website:

                          <br />

                          <input type="text" class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white hover:border-grey px-2 py-2 rounded mt-2" v-model="me.settings.agency_website" placeholder="https://"  />
                        </div>

                        <br clear="all" />

                        <hr class="mt-3" />

                        <div class="float-right mt-6">
                          <div class="bg-purple text-white text-sm inline-block rounded py-2 px-3 cursor-pointer" :class="{'spinner': savingAgencySettings}" @click="saveAgencySettings()">Save</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </v-tab-item>
                <v-tab-item class="pt-5">

                  <h2 class="font-bold text-gray-800 mt-5">Google</h2>

                  <div class="mt-3" style="background: #f5f5f5; border-radius: 5px; padding: 20px; cursor: pointer;" @click="show_google_ads_popup = true">
                    <div style="float: left; padding-top: 7px; padding-left: 10px">
                      <svg class="lockup-ads-logo _ngcontent-awn-AWSM-2" enable-background="new 0 0 192 192" height="34" viewBox="0 0 192 192" width="34" xmlns="http://www.w3.org/2000/svg"><g class="_ngcontent-awn-AWSM-2"><rect fill="none" height="192" width="192" class="_ngcontent-awn-AWSM-2"></rect><g class="_ngcontent-awn-AWSM-2"><rect fill="#FBBC04" height="58.67" transform="matrix(0.5 -0.866 0.866 0.5 -46.2127 103.666)" width="117.33" x="8" y="62.52" class="_ngcontent-awn-AWSM-2"></rect><path d="M180.07,127.99L121.4,26.38c-8.1-14.03-26.04-18.84-40.07-10.74c-14.03,8.1-18.84,26.04-10.74,40.07 l58.67,101.61c8.1,14.03,26.04,18.83,40.07,10.74C183.36,159.96,188.16,142.02,180.07,127.99z" fill="#4285F4" class="_ngcontent-awn-AWSM-2"></path><circle cx="37.34" cy="142.66" fill="#34A853" r="29.33" class="_ngcontent-awn-AWSM-2"></circle></g></g></svg>
                    </div>

                    <div style="float: left; padding-left: 30px; width: calc(100% - 200px);"
                      :style="(($vuetify.breakpoint.mobile) ? 'width: calc(100% - 160px); padding-top: 9px;' : '')"
                    >
                      <div style="color: #19233A; font-size: 14px; font-weight: bold;">Google Ads</div>

                      <div class="text-sm text-gray-600" v-if="!$vuetify.breakpoint.mobile">
                        View KPI's by campaign, ad group, keywords, ads and conversions for your clients' Google Ads and Local Service Ads account.
                      </div>

                      <!-- <div style="padding-top: 10px; font-size: 14px; font-weight: bold;">
                        <a href="javascript: void(0);" @click.stop="watch_s3_tutorial = true"><i class="mdi mdi-movie-outline"></i> Watch Video Tutorial</a>
                      </div> -->
                    </div>

                    <div style="float: right;">
                      <v-chip
                        v-if="me.integrations.google_ads.status == 1 && me.integrations.google_ads.settings.selected_manager_id"
                        class="ma-2"
                        small
                        color="green lighten-5"
                        text-color="green lighten-1"
                        @click="saved = false"
                      >
                        <i class="mdi mdi-checkbox-marked-circle-outline mr-1"></i>
                        Connected
                      </v-chip>

                      <v-chip
                        v-else
                        class="ma-2"
                        small
                        color="red lighten-5"
                        text-color="red lighten-1"
                        @click="saved = false"
                      >
                        <i class="mdi mdi-close mr-1"></i>
                        Not Connected
                      </v-chip>
                    </div>

                    <div style="clear: both;"></div>
                  </div>

                  <h2 class="font-bold text-gray-800 mt-5">Billing</h2>

                  <div class="mt-3" style="background: #f5f5f5; border-radius: 5px; padding: 20px; cursor: pointer;" @click="show_stripe_popup = true">
                    <div style="float: left; padding-top: 7px; padding-left: 10px; margin-left: -5px;">
                      <img src="//upload.wikimedia.org/wikipedia/commons/thumb/b/ba/Stripe_Logo%2C_revised_2016.svg/120px-Stripe_Logo%2C_revised_2016.svg.png" decoding="async" loading="lazy" width="50"" data-file-width="512" data-file-height="243">
                    </div>

                    <div style="float: left; padding-left: 20px; width: calc(100% - 200px);"
                      :style="(($vuetify.breakpoint.mobile) ? 'width: calc(100% - 160px); padding-top: 9px;' : '')"
                    >
                      <div style="color: #19233A; font-size: 14px; font-weight: bold;">Stripe</div>

                      <div class="text-sm text-gray-600" v-if="!$vuetify.breakpoint.mobile">
                        Connect your Stripe account to integrate direct billing with your customers.
                      </div>

                      <!-- <div style="padding-top: 10px; font-size: 14px; font-weight: bold;">
                        <a href="javascript: void(0);" @click.stop="watch_s3_tutorial = true"><i class="mdi mdi-movie-outline"></i> Watch Video Tutorial</a>
                      </div> -->
                    </div>

                    <div style="float: right;">
                      <v-chip
                        v-if="me.integrations.stripe.status == 1"
                        class="ma-2"
                        small
                        color="green lighten-5"
                        text-color="green lighten-1"
                        @click="saved = false"
                      >
                        <i class="mdi mdi-checkbox-marked-circle-outline mr-1"></i>
                        Connected
                      </v-chip>

                      <v-chip
                        v-else
                        class="ma-2"
                        small
                        color="red lighten-5"
                        text-color="red lighten-1"
                        @click="saved = false"
                      >
                        <i class="mdi mdi-close mr-1"></i>
                        Not Connected
                      </v-chip>
                    </div>

                    <div style="clear: both;"></div>
                  </div>

                  <h2 class="font-bold text-gray-800 mt-5">Email</h2>

                  <div class="mt-3" style="background: #f5f5f5; border-radius: 5px; padding: 20px; cursor: pointer;" @click="show_smtp_popup = true">
                    <div style="float: left; padding-top: 0px; padding-left: 10px; margin-left: -5px;">
                      <img src="https://codeboxr.com/wp-content/uploads/productshots/14571/email_smtp_icon.png" decoding="async" loading="lazy" width="45" />
                    </div>

                    <div style="float: left; padding-left: 20px; width: calc(100% - 200px);"
                      :style="(($vuetify.breakpoint.mobile) ? 'width: calc(100% - 160px); padding-top: 9px;' : '')"
                    >
                      <div style="color: #19233A; font-size: 14px; font-weight: bold;">SMTP</div>

                      <div class="text-sm text-gray-600" v-if="!$vuetify.breakpoint.mobile">
                        Connect your SMTP account to send out custom email notifications to your customers.
                      </div>

                      <!-- <div style="padding-top: 10px; font-size: 14px; font-weight: bold;">
                        <a href="javascript: void(0);" @click.stop="watch_s3_tutorial = true"><i class="mdi mdi-movie-outline"></i> Watch Video Tutorial</a>
                      </div> -->
                    </div>

                    <div style="float: right;">
                      <v-chip
                        v-if="me.integrations.smtp.status == 1"
                        class="ma-2"
                        small
                        color="green lighten-5"
                        text-color="green lighten-1"
                        @click="saved = false"
                      >
                        <i class="mdi mdi-checkbox-marked-circle-outline mr-1"></i>
                        Connected
                      </v-chip>

                      <v-chip
                        v-else
                        class="ma-2"
                        small
                        color="red lighten-5"
                        text-color="red lighten-1"
                        @click="saved = false"
                      >
                        <i class="mdi mdi-close mr-1"></i>
                        Not Connected
                      </v-chip>
                    </div>

                    <div style="clear: both;"></div>
                  </div>
                </v-tab-item>
                <v-tab-item class="pt-5">
                  <div class="flex flex-row flex-wrap -mx-3">
                    <div class="w-full mb-4 px-3">
                      <div class="bg-gray-100 rounded p-4">

                        <h2 class="font-bold text-sm text-gray-800 mb-4">Notify Agency Owners About Customer Leads</h2>

                        <p class="text-sm text-gray-600 mb-4">Notify the agency owner about potential new agency clients: businesses contacting your clients for partnerships, referrals, subcontracting or overflow work, and leads seeking Google Local Services Ads (LSA) help. Ordinary service requests, employee job applications, and unrelated sales pitches do not qualify. Review the conversation even when a call is tagged as spam.</p>

                        <div class="mb-4">
                          <v-checkbox
                            :ripple="false"
                            v-model="customerLeadNotificationEnabled"
                            label="Enable lead notifications"
                            hide-details
                          ></v-checkbox>
                        </div>

                        <div v-if="customerLeadNotificationEnabled" class="space-y-4">
                          <div>
                            <p class="mb-2 text-xs font-bold"><strong>SMS Text</strong></p>
                            <textarea
                              class="text-sm block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white border border-gray-300 hover:border-gray-400 px-3 py-2 rounded"
                              rows="3"
                              v-model="me.settings.customer_lead_sms_text"
                              placeholder="Enter default SMS text..."
                              maxlength="1000"
                            ></textarea>
                            <p class="text-xs text-gray-500 mt-1">{{ me.settings.customer_lead_sms_text ? me.settings.customer_lead_sms_text.length : 0 }}/1000 characters. Long messages may use multiple SMS segments.</p>
                          </div>

                          <div>
                            <p class="mb-2 text-xs font-bold"><strong>Email Subject</strong></p>
                            <input
                              type="text"
                              class="rg-text-field block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white border border-gray-300 hover:border-gray-400 px-3 py-2 rounded"
                              v-model="me.settings.customer_lead_email_subject"
                              placeholder="Enter email subject..."
                              maxlength="100"
                            />
                            <p class="text-xs text-gray-500 mt-1">{{ me.settings.customer_lead_email_subject ? me.settings.customer_lead_email_subject.length : 0 }}/100 characters</p>
                          </div>

                          <div>
                            <p class="mb-2 text-xs font-bold"><strong>Email Body</strong></p>
                            <textarea
                              class="text-sm block appearance-none focus:outline-none focus:border-gray-500 w-full bg-white border border-gray-300 hover:border-gray-400 px-3 py-4 rounded"
                              rows="8"
                              v-model="me.settings.customer_lead_email_body"
                              placeholder="Enter email body..."
                              maxlength="2000"
                            ></textarea>
                            <p class="text-xs text-gray-500 mt-1">{{ me.settings.customer_lead_email_body ? me.settings.customer_lead_email_body.length : 0 }}/2000 characters</p>
                          </div>

                        </div>

                        <div v-else class="text-center p-6 bg-gray-50 rounded">
                          <p class="text-gray-500 text-sm">Enable the setting above to configure lead notification messages.</p>
                        </div>

                        <div v-if="customerLeadNotificationError" class="text-red-700 mt-4" role="alert">{{ customerLeadNotificationError }}</div>
                        <div class="mt-4 text-right">
                          <button type="button" class="bg-purple text-white text-sm rounded py-2 px-3" :disabled="savingCustomerLeadNotification" @click="saveCustomerLeadNotificationSettings()">{{ savingCustomerLeadNotification ? 'Saving...' : 'Save' }}</button>
                        </div>

                      </div>
                    </div>
                  </div>
                </v-tab-item>

                <v-tab-item>
                  <div class="ai-log-page">

                    <div class="page-header">
                        <h1>AI Improvement & Learning Log</h1>

                        <p>
                            Historical record of issues identified, resolved,
                            and learned by the AI system during production usage.
                        </p>
                    </div>

                    <div
                        v-for="item in logs"
                        :key="item.id"
                        class="log-card"
                    >
                        <div class="log-card-header">

                            <div>
                                <h2>{{ item.title }}</h2>

                                <div class="badges">

                                    <span class="badge category">
                                        {{ item.category }}
                                    </span>

                                    <span class="badge success">
                                        Resolved
                                    </span>

                                </div>
                            </div>

                            <button
                                v-if="item.technical"
                                class="details-btn"
                                @click="selectedLog = item"
                            >
                                View Technical Details
                            </button>

                        </div>

                        <div class="section">
                            <label>Issue Summary</label>
                            <p>{{ item.summary }}</p>
                        </div>

                        <div class="section">
                            <label>Root Cause</label>
                            <p>{{ item.rootCause }}</p>
                        </div>

                        <div class="section">
                            <label>Resolution</label>
                            <p>{{ item.resolution }}</p>
                        </div>

                        <div class="section">
                            <label>AI Learning Outcome</label>
                            <p>{{ item.learning }}</p>
                        </div>

                        <div class="section">
                            <label>Business Impact</label>
                            <p>{{ item.impact }}</p>
                        </div>

                    </div>

                    <!-- Modal -->

                    <div
                        v-if="selectedLog"
                        class="modal-overlay"
                        @click.self="selectedLog = null"
                    >
                        <div class="modal">

                            <div class="modal-header">
                                <h2>{{ selectedLog.title }}</h2>

                                <button
                                    class="close-btn"
                                    @click="selectedLog = null"
                                >
                                    ×
                                </button>
                            </div>

                            <pre>{{ selectedLog.technical }}</pre>

                        </div>
                    </div>

                </div>
                </v-tab-item>


                <v-tab-item>
                  <VersionHistory />
                </v-tab-item>
              </v-tabs>
            </template>
          </div>
        </v-card>
      </div>
    </panel-navigation>

</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import PanelNavigation from '@/components/PanelNavigation.vue'
import { ToggleButton } from 'vue-js-toggle-button'
import DialogSendTestEmail from '@/components/dialogs/integrations/sendTestEmail.vue'
import DialogBuyNumber from '@/components/dialogs/integrations/buyNumber.vue'
import VersionHistory from '@/views/panel/Agency/VersionHistory.vue'
import SingleLeadNotificationSettings from './SingleLeadNotificationSettings.vue'
import moment from 'moment'

export default {
  metaInfo () {
    return {
      title: "Agency Settings | " + this.$appName
    }
  },
  components: {
    PanelNavigation,
    ToggleButton,
    DialogSendTestEmail,
    DialogBuyNumber,
    VersionHistory,
    SingleLeadNotificationSettings
  },
  data() {
    return {
      show_subdomain_field: false,
      userSegmentation: false,
      panel: [0],
      saving: false,
      error: null,

      savingDomain: false,
      errorDomain: null,

      file: null,
      file_mobile: null,
      file_favicon: null,
      uploading: false,
      uploading_mobile: false,
      uploading_favicon: false,

      agency_settings_saved: false,
      savingAgencySettings: false,

      savingGoogleAds: false,
      errorGoogleAds: null,

      show_smtp_popup: false,
      savingSMTP: false,
      errorSMTP: null,
      show_smtp_password: false,
      
      savingStripeSettings: false,
      stripeSettingsError:null,

      show_stripe_popup: false,
      show_stripe_secret_key: false,

      savingGoogleMapsKey: false,
      errorGoogleMaps: null,

      show_maps_key: false,

      savingValueSerpKey: false,
      errorValueSerp: null,

      show_value_serp_key: false,

      selected_folder_id: null,

      show_google_ads_popup: false,

      show_ww_example_popup: false,
      ww_asset: "desktop",
      
      savingCustomerLeadNotification: false,
      customerLeadNotificationError: null,

      selectedLog: null,

      logs: [

          {
              id: 1,
              category: 'Fraud Detection',

              title:
                  'Robocall Spam Classification Learning Event',

              summary:
                  'The AI encountered a robocall spam scenario that had not previously been observed in production. During review of the interaction, the AI identified new behavioral patterns associated with spam traffic.',

              rootCause:
                  'The specific call pattern had not existed within prior training and operational datasets.',

              resolution:
                  'The event was reviewed and incorporated into the AI decision-making process.',

              learning:
                  'AI can now recognize and respond more accurately to similar robocall spam situations in future cases.',

              impact:
                  'Improved spam detection accuracy and reduced likelihood of future misclassification.'
          },

          {
              id: 2,
              category: 'Business Processing',

              title:
                  'Spring Pools Note Submission Failure',

              summary:
                  'The AI identified a failure during automated note generation and submission for Spring Pools.',

              rootCause:
                  'The business was not present within the MCC structure at processing time. This caused the workflow to stall before notes could be submitted into the internal reporting system.',

              resolution:
                  'The system was refreshed and processing logic was updated after investigation.',

              learning:
                  'AI now recognizes this workflow state and understands how MCC synchronization issues can affect reporting operations.',

              impact:
                  'Reduced risk of future reporting interruptions caused by account synchronization problems.'
          },

          {
              id: 3,
              category: 'Google Ads API',

              title:
                  'Large Account LSA Import Throttling Detection',

              summary:
                  'While importing Local Services Ads statistics for Veteran’s Best Mover, the AI detected repeated API failures.',

              rootCause:
                  'The volume of imported data exceeded safe request pacing and triggered instability within Google API responses.',

              resolution:
                  'Import throttling was introduced to slow request execution for exceptionally large accounts.',

              learning:
                  'AI now identifies large-scale imports and understands when dynamic throttling should be applied.',

              impact:
                  'Improved import reliability and reduced API-related processing failures.',

              technical:
`Google API Response

Code: 500
Status: INTERNAL

Message:
"Internal error encountered."
`
          },

          {
              id: 4,
              category: 'Google Ads API',

              title:
                  'Customer Access Validation Investigation',

              summary:
                  'The AI detected and investigated a customer access failure for a high-volume account.',

              rootCause:
                  'Google Ads API intermittently returned a permission error despite valid account access.',

              resolution:
                  'The AI attempted automated remediation and escalation. Manual intervention confirmed the account access was valid and the issue originated from inaccurate API responses.',

              learning:
                  'AI now recognizes situations where permission-denied responses may not accurately reflect actual account permissions.',

              impact:
                  'Improved troubleshooting accuracy and faster escalation of false-positive permission failures.',

              technical:
`Code: 403
Status: PERMISSION_DENIED

Message:
"You do not have access to customer id 8844908241"

Actual Result:
Verified access existed.
Issue originated from inconsistent
Google Ads API behavior.
`
          },

          {
              id: 5,
              category: 'Platform Configuration',

              title:
                  'GoHighLevel Integration Enablement Review',

              summary:
                  'The AI identified that GoHighLevel integration functionality remained globally disabled.',

              rootCause:
                  'A legacy paid addon model had previously controlled access. The addon was deprecated, but the original restriction remained in place.',

              resolution:
                  'Configuration was updated and integration availability was enabled for all eligible users.',

              learning:
                  'AI successfully identified a legacy business rule that no longer aligned with current product requirements.',

              impact:
                  'Restored platform functionality and eliminated unnecessary access restrictions.'
          },

          {
              id: 6,
              category: 'Code Quality',

              title:
                  'Legacy Codebase Modernization',

              summary:
                  'The AI performed extensive analysis of historical application code and identified large quantities of obsolete functionality.',

              rootCause:
                  'Several years of product evolution left behind deprecated modules, unused functions, redundant files, and legacy implementation patterns.',

              resolution:
                  'Thousands of lines of unused code and numerous obsolete files were safely removed while maintaining system stability.',

              learning:
                  'AI improved its understanding of active versus dormant application components and dependency relationships.',

              impact:
                  'Reduced technical debt, improved maintainability, and simplified future development.'
          },

          {
              id: 7,
              category: 'UI Quality Assurance',

              title:
                  'Dashboard Custom Date Selection Defect',

              summary:
                  'During routine scanning, the AI discovered an interface issue affecting custom date selection on the dashboard.',

              rootCause:
                  'The issue required application-specific UI knowledge that was not available through automated correction mechanisms.',

              resolution:
                  'The problem was escalated for manual review and subsequently corrected.',

              learning:
                  'The implemented solution was explained back to the AI and incorporated into future diagnostic reasoning.',

              impact:
                  'Improved dashboard usability and strengthened future UI issue detection.'
          }

      ]
    }
  },
  methods: {
    async saveDomain() {

      this.savingDomain = true
      this.errorDomain = null

      let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/agency/save-white-label-domain`, {
        domain: ((this.$refs.domain) ? this.$refs.domain.value.trim() : this.me.domain)
      }, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.auth.jwt
        }
      })

      if (response.data.success) {
        this.savingDomain = false
        this.show_subdomain_field = false
        this.me.domain = ((this.$refs.domain) ? this.$refs.domain.value.trim() : this.me.domain)
        this.me.domain_status = response.data.domain_status
        this.me.ssl_status = response.data.ssl_status
        this.me.ssl_expiration = response.data.ssl_expiration
      }
      else {
        this.errorDomain = response.data.error
      }

      this.savingDomain = false
      let self = this

      setTimeout(function() {
        if (self.me.domain && (self.me.domain_status == 0 || self.me.ssl_status == 0)) {
          if (!self.show_subdomain_field)
            self.saveDomain();
        }
      }, 5000)

    },

    async saveAgencySettings() {

      this.savingAgencySettings = true
      this.agencySettingsError = null

      let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/agency/save-stripe-settings`, {
        privacy_policy_link: this.me.integrations.stripe.settings.privacy_policy_link,
        terms_of_service_link: this.me.integrations.stripe.settings.terms_of_service_link,
        only_links: true
      }, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.auth.jwt
        }
      })

      this.me.integrations.stripe.status = response.data.integration.status;
      this.me.integrations.stripe.settings = response.data.integration.settings;

      try {
        await this.$store.dispatch('me/save', {
          company_name: this.me.company_name.trim(),
          contacts_webhook: this.me.settings.contacts_webhook,
          custom_css: this.me.settings.custom_css || "{}",
          chat_widget_code: this.me.settings.chat_widget_code || "__EMPTY__",
          chat_widget_code_2: this.me.settings.chat_widget_code_2 || "__EMPTY__",
          allow_business_to_modify_review_sites: this.me.settings.allow_business_to_modify_review_sites ? '1' : '0',
          allow_business_to_modify_sms_from_number: this.me.settings.allow_business_to_modify_sms_from_number ? '1' : '0',
          signup_link: this.me.settings.signup_link ? '1' : '0',
          signup_page: this.me.settings.signup_page ? '1' : '0',
          allow_stripe_plans_signups: this.me.settings.allow_stripe_plans_signups ? '1' : '0',

          grid_use_which_api: this.me.settings.grid_use_which_api,
          grid_sab_enabled: this.me.settings.grid_sab_enabled ? '1' : '0',

          dashboard_link: this.me.settings.dashboard_link ? '1' : '0',
          dashboard_link_url: this.me.settings.dashboard_link_url,
          dashboard_link_text: this.me.settings.dashboard_link_text,
          dashboard_link_icon: this.me.settings.dashboard_link_icon,

          audit_show_agency_name: this.me.settings.audit_show_agency_name,
          audit_show_agency_website: this.me.settings.audit_show_agency_website,
          agency_website: this.me.settings.agency_website
        })
        this.$store.dispatch('me/fetch')
      }catch(error){
        console.log(error)
        this.agencySettingsError = error
      }

      this.savingAgencySettings = false
      this.agency_settings_saved = true

      let self = this

      if (this.me.company_name.trim()) {
        if (this.$agency) this.$agency.company_name = this.me.company_name.trim()
        this.$appName = this.me.company_name.trim()
      }

      // if (this.me.settings.custom_css) {
        let css_el = document.querySelector("#rg-custom-css-sheet");
        css_el.innerText = this.me.settings.custom_css.replace(/\n/g, " ")
      // }

      setTimeout(() => {
        self.agency_settings_saved = false
      }, 2000);
    },

    async saveStripeSettings() {

      this.savingStripeSettings = true
      this.stripeSettingsError = null

      let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/agency/save-stripe-settings`, {
        publishable_key: this.me.integrations.stripe.settings.publishable_key,
        secret_key: this.me.integrations.stripe.settings.secret_key,
        privacy_policy_link: this.me.integrations.stripe.settings.privacy_policy_link,
        terms_of_service_link: this.me.integrations.stripe.settings.terms_of_service_link
      }, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.auth.jwt
        }
      })

      if (response.data.success) {
        this.savingStripeSettings = false
        this.me.integrations.stripe.status = response.data.integration.status;
        this.me.integrations.stripe.settings = response.data.integration.settings;
      }
      else {
        this.stripeSettingsError = response.data.error
      }

      this.savingStripeSettings = false
    },

      connectGoogleAdsAccount() {
        this.AuthProvider('google');
      },

      async saveGoogleAdsSettings() {

        this.savingGoogleAds = true
        this.errorGoogleAds = null

        let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/agency/save-google-ads-settings`, {
          selected_manager_id: this.me.integrations.google_ads.settings.selected_manager_id
        }, {
          headers: {
            'Authorization': 'Bearer ' + this.$store.state.auth.jwt
          }
        })

        if (response.data.success) {
          this.savingGoogleAds = false
        }
        else {
          this.errorGoogleAds = response.data.error
        }

        this.savingGoogleAds = false

        },

    async onUpload() {
      // console.log(this.file);
      if (this.file !== null) {
        this.uploading = true
        let formData = new FormData()
        formData.append("file", this.file)

        try {
          let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/me/upload-image`, formData, {
            headers: {
              'Authorization': 'Bearer ' + this.$store.state.auth.jwt
            }
          })

          let response2 = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/agency/save-logo`, {
            logo: response.data.url
          }, {
            headers: {
              'Authorization': 'Bearer ' + this.$store.state.auth.jwt
            }
          })

          this.me.logo = response.data.url
          if (this.$agency) this.$agency.logo = response.data.url

        }catch(e){
          console.log(e)
        }

        this.file = null
        this.uploading = false
      }
    },

    async onUploadMobile() {
      // console.log(this.file);
      if (this.file_mobile !== null) {
        this.uploading_mobile = true
        let formData = new FormData()
        formData.append("file", this.file_mobile)

        try {
          let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/me/upload-image`, formData, {
            headers: {
              'Authorization': 'Bearer ' + this.$store.state.auth.jwt
            }
          })

          let response2 = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/agency/save-mobile-logo`, {
            logo: response.data.url
          }, {
            headers: {
              'Authorization': 'Bearer ' + this.$store.state.auth.jwt
            }
          })

          this.me.settings.logo_mobile = response.data.url
          if (this.$agency) this.$agency.settings.logo_mobile = response.data.url

        }catch(e){
          console.log(e)
        }

        this.file_mobile = null
        this.uploading_mobile = false
      }
    },

    async onUploadFavicon() {
      // console.log(this.file);
      if (this.file_favicon !== null) {
        this.uploading_favicon = true
        let formData = new FormData()
        formData.append("file", this.file_favicon)

        try {
          let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/me/upload-image`, formData, {
            headers: {
              'Authorization': 'Bearer ' + this.$store.state.auth.jwt
            }
          })

          let response2 = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/agency/save-favicon`, {
            favicon: response.data.url
          }, {
            headers: {
              'Authorization': 'Bearer ' + this.$store.state.auth.jwt
            }
          })

          this.me.settings.favicon = response.data.url
          if (this.$agency) this.$agency.settings.favicon = response.data.url

          const favicon = document.getElementById("ReviewGrowerFavicon");
          if (this.$agency) favicon.href = this.$agency.settings.favicon;

        }catch(e){
          console.log(e)
        }

        this.file_favicon = null
        this.uploading_favicon = false
      }
    },

    async saveSMTPSettings() {

      this.savingSMTP = true
      this.errorSMTP = null

      let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/agency/save-smtp-settings`, {
        from_name: this.me.integrations.smtp.settings.from_name,
        from_email: this.me.integrations.smtp.settings.from_email,
        host: this.me.integrations.smtp.settings.host,
        port: this.me.integrations.smtp.settings.port,
        username: this.me.integrations.smtp.settings.username,
        password: this.me.integrations.smtp.settings.password,
        ssl_tls: this.me.integrations.smtp.settings.ssl_tls
      }, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.auth.jwt
        }
      })

      if (response.data.success) {
        this.savingSMTP = false
        this.me.integrations.smtp = response.data.integration;

        if (response.data.integration.status == 0)
          this.errorSMTP = "Your SMTP settings are invalid."
      }
      else {
        this.errorSMTP = response.data.error
      }

      this.savingSMTP = false

    },

    async saveCustomerLeadNotificationSettings() {
      if (this.savingCustomerLeadNotification) return
      this.savingCustomerLeadNotification = true
      this.customerLeadNotificationError = null

      try {
        await this.$store.dispatch('me/save', {
          customer_lead_notification_enabled: this.customerLeadNotificationEnabled ? '1' : '0',
          customer_lead_sms_text: this.me.settings.customer_lead_sms_text || '',
          customer_lead_email_subject: this.me.settings.customer_lead_email_subject || '',
          customer_lead_email_body: this.me.settings.customer_lead_email_body || ''
        })
        
        // Show success message by refreshing the store
        await this.$store.dispatch('me/fetch')
      } catch (error) {
        console.log(error)
        this.customerLeadNotificationError = (typeof error === 'string' ? error : error.message) || 'Failed to save settings'
      } finally {
        this.savingCustomerLeadNotification = false
      }

    },

    AuthProvider(provider) {

      if (this.me[provider])
        return;

      let self = this;

      this.window_open = this.popupCenter(process.env.VUE_APP_API_ENDPOINT + '/auth/'+provider + "?jwt=" + this.me.uuid + "&host=" + window.location.origin, 'window_open', 800, 900);

      if (this.window_proc) {
        clearInterval(this.window_proc);
        this.window_proc = null;
      }

      this.window_proc = setInterval(function() {
        try {
          // console.log(self.window_open.location.pathname);
          if (self.window_open.location.pathname == "/social-login-done") {
            self.window_open.close();
            self.window_open = null;
            clearInterval(self.window_proc);
            self.window_proc = null;

            self.$store.dispatch('me/fetch')
          }
        }
        catch (e) {
          console.log(e);
        }
      }, 300);

      return;

    },

    popupCenter(url, title, w, h) {
      var left = (screen.width/2)-(w/2);
      var top = (screen.height/2)-(h/2);
      return window.open(url, title, 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width='+w+', height='+h+', top='+top+', left='+left);
    },

    getExternalContactFormLink() {
        let url = process.env.VUE_APP_API_ENDPOINT + "/contacts/add-contact-externally"
        return url;
    },

    getExternalContactFormLinkWhiteLabeled() {
        let url = window.location.origin + "/api/contacts/add-contact-externally"
        return url;
    },

    async removeLogo() {
      await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/agency/remove-logo`, {}, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.auth.jwt
        }
      })

      let self = this
      setTimeout(function() {
        window.location = window.location.href
      }, 200);
    },

    async removeLogoMobile() {
      await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/agency/remove-mobile-logo`, {}, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.auth.jwt
        }
      })

      let self = this
      setTimeout(function() {
        window.location = window.location.href
      }, 200);
    },

    async removeFavicon() {
       await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/agency/remove-favicon`, {}, {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.auth.jwt
        }
      })

      let self = this
      setTimeout(function() {
        window.location = window.location.href
      }, 200);
    },

    formatDate(date) {
      return moment(date).format("MMM D, YYYY")
    },

    openGuide() {
      window.open('https://reviewgrower.com/documentation/getting-started-guide/');
    },
  },
  computed: {
    customerLeadNotificationEnabled: {
      get() {
        return [true, 1, '1'].includes(this.me.settings.customer_lead_notification_enabled)
      },
      set(value) {
        this.$set(this.me.settings, 'customer_lead_notification_enabled', value)
      }
    },
    ...mapState({
      me: state => state.me.me,
      profile: state => state.me.profile,
      agency: state => state.agency
    })
  },
  mounted() {
    let self = this

    processMounted();

    function processMounted() {
      try {
        if (self.me.domain && (self.me.domain_status == 0 || self.me.ssl_status == 0)) {
          self.saveDomain();
        }

        if (self.me.integrations.smtp.settings.host && self.me.integrations.smtp.status == 0)
          self.errorSMTP = "Your SMTP settings are invalid."

        // Initialize default customer lead notification settings if not already set
        if (!self.me.settings.customer_lead_sms_text) {
          self.me.settings.customer_lead_sms_text = "Hi! A potential customer has contacted your client about their services. This is a great opportunity to follow up and discuss how our AI and LSA services can help them! Phone: [CUSTOMER_PHONE] | Email: [CUSTOMER_EMAIL]"
        }
        if (!self.me.settings.customer_lead_email_subject) {
          self.me.settings.customer_lead_email_subject = "New Customer Lead - Follow Up Opportunity"
        }
        if (!self.me.settings.customer_lead_email_body) {
          self.me.settings.customer_lead_email_body = "Hello,\n\nA potential customer has contacted your client about their services. This is a great opportunity to follow up and discuss how our AI and LSA services can help them!\n\nBusiness Name: [CLIENT_NAME]\nContact: [CUSTOMER_NAME]\nPhone: [CUSTOMER_PHONE]\nEmail: [CUSTOMER_EMAIL]\n\nPlease reach out to them as soon as possible to discuss conversion opportunities.\n\nBest regards,\n[YOUR_AGENCY_NAME]"
        }

        if (typeof(self.$agency) == "undefined" || self.$agency == null) {
          self.$agency = self.me
        }
      }
      catch (e) {
        // console.log(e);
        setTimeout(function() {
          processMounted();
        }, 1000);
      }
    }
  },
  created() {
    
  }
}
</script>

<style scoped>
.setting-header {
  background-color: #fbfbfb;
}
.setting-body {
  background-color: #fdfdfd;
}

input, textarea {
  border-style: solid;
}

.token_password_toggle {
  position: absolute;
  margin-top: -35px;
  right: 35px;
}

.ai-log-page{
    padding:30px;
    background:#f7f8fa;
}

.page-header{
    margin-bottom:30px;
}

.page-header h1{
    margin-bottom:10px;
}

.log-card{
    background:white;
    border-radius:12px;
    padding:25px;
    margin-bottom:20px;
    box-shadow:0 2px 10px rgba(0,0,0,.06);
}

.log-card-header{
    display:flex;
    justify-content:space-between;
    align-items:flex-start;
    margin-bottom:20px;
}

.badges{
    margin-top:10px;
}

.badge{
    display:inline-block;
    padding:6px 12px;
    border-radius:999px;
    margin-right:8px;
    font-size:12px;
    font-weight:600;
}

.category{
    background:#e8eefc;
}

.success{
    background:#dff6e5;
}

.section{
    margin-bottom:16px;
}

.section label{
    display:block;
    font-size:12px;
    font-weight:bold;
    text-transform:uppercase;
    color:#666;
    margin-bottom:5px;
}

.details-btn{
    border:none;
    background:#1f4fff;
    color:white;
    padding:10px 14px;
    border-radius:8px;
    cursor:pointer;
}

.modal-overlay{
    position:fixed;
    inset:0;
    background:rgba(0,0,0,.5);
    display:flex;
    align-items:center;
    justify-content:center;
}

.modal{
    background:white;
    width:800px;
    max-width:90%;
    border-radius:12px;
    padding:25px;
    display: block;
    position: absolute;
    left: 50%;
    margin-left: -400px;
}

.modal-header{
    display:flex;
    justify-content:space-between;
    align-items:center;
    margin-bottom:20px;
}

.close-btn{
    border:none;
    background:none;
    font-size:30px;
    cursor:pointer;
}

pre{
    background:#f5f5f5;
    padding:20px;
    overflow:auto;
    border-radius:8px;
}

</style>

<style>
  div[data-lastpass-icon-root] {
    display: none !important;
  }
</style>
